import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-dashboard',
  templateUrl: './error-dashboard.component.html',
  styleUrls: ['./error-dashboard.component.scss']
})
export class ErrorDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
